import API from "../utils/api";


const createAttribute = async (data) => {
  const response = await API.post("/api/attributes", data);
  return response.data;
};

const getallAttributes = async (activeOnly = false) => {
  const response = await API.get(`/api/attributes?activeOnly=${activeOnly}`);
  return response.data;
};

const getSingleAttribute = async (id) => {
  const response = await API.get(`/api/attributes/${id}`);
  return response.data;
};

const updateAttribute = async (id, data) => {
  const response = await API.put(`/api/attributes/${id}`, data);
  return response.data;
};

const deleteAttribute = async (id) => {
  const response = await API.delete(`/api/attributes/${id}`);
  return response.data;
};

const activateAttribute = async (id) => {
  const response = await API.put(`/api/attributes/${id}/activate`);
  return response.data;
};

const attributeService = {
  createAttribute,
  getallAttributes,
  getSingleAttribute,
  updateAttribute,
  deleteAttribute,
  activateAttribute,
};

export default attributeService;